import React, { FC } from "react";
import { BsPinAngle } from "react-icons/bs";
import { MdOutlineEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { TrashSvg } from "../../../../../../components/svg/TrashSvg";
import { usePinOrganizationNoteMutation } from "../../../../../../slices/OrganizationNotesSlice";
import { usePinWorkNoteMutation } from "../../../../../../slices/WorkNotesSlice";
import { IOrganizationContactNote } from "../../../../../../types/types";
import {
  mapNoteToViewModel,
  NoteCard,
  useCanEditNote,
} from "../../../../components/notes";

type Props = {
  note: IOrganizationContactNote;
  setCurrentNote: (value: IOrganizationContactNote | null) => void;
  setIsOpenAdd: (isOpenAdd: boolean) => void;
  deleteOrganizationNote: (value: IOrganizationContactNote) => void;
  setIsWork: React.Dispatch<React.SetStateAction<boolean>>;
  onViewNote: (note: IOrganizationContactNote) => void;
};

export const OrganizationNote: FC<Props> = ({
  note,
  setCurrentNote,
  setIsOpenAdd,
  deleteOrganizationNote,
  setIsWork,
  onViewNote,
}) => {
  const navigate = useNavigate();
  const canEdit = useCanEditNote();
  const [pinNote, { isLoading: isLoadingPin }] =
    usePinOrganizationNoteMutation();
  // Work notes in this list are pinned through the work item (QA batch 14).
  const [pinWorkNote, { isLoading: isLoadingWorkPin }] =
    usePinWorkNoteMutation();

  return (
    <NoteCard
      note={mapNoteToViewModel(note)}
      onView={() => onViewNote(note)}
      onOpenWork={(workId) => navigate("/work/" + workId)}
      actions={[
        ...(canEdit(note)
          ? [
              {
                name: "Edit",
                action: () => {
                  setCurrentNote({ ...note, noteId: note.noteId });
                  setIsWork(!!note.workName);
                  setIsOpenAdd(true);
                },
                icon: <MdOutlineEdit size={20} />,
              },
            ]
          : []),
        {
          name: note.isPinned ? "Unpin" : "Pin",
          action: () => {
            if (!isLoadingPin && !isLoadingWorkPin) {
              const pin = note?.workId ? pinWorkNote : pinNote;
              pin({
                id: note?.noteId || note?.id || "",
                isPinned: !note?.isPinned,
              });
            }
          },
          icon: <BsPinAngle size={20} />,
        },
        {
          name: "Delete",
          action: () => deleteOrganizationNote(note),
          icon: <TrashSvg />,
          extraClasses: "text-[#DC2626]",
          iconColor: "text-[#DC2626]",
        },
      ]}
    />
  );
};
